import * as yup from "yup";

const addBlogsSchema = yup.object().shape({
  name: yup.string().required("Blog Titlle is required"),
  short_description: yup.string().required("Short Discription is required"),
  slug: yup.string().required("Slug is required"),
  description: yup.string().required("Discription is required"),
  metaTitle: yup.string().required("Meta Title is required"),
  metaDescription: yup.string().required("Meta Description is required"),
  imageAltText: yup.string().required("Image Alt text is required"),
});

export { addBlogsSchema };
